import { render, staticRenderFns } from "./ReviewerReview.vue?vue&type=template&id=4712a1e6&"
import script from "./ReviewerReview.vue?vue&type=script&lang=js&"
export * from "./ReviewerReview.vue?vue&type=script&lang=js&"
import style0 from "./ReviewerReview.vue?vue&type=style&index=0&id=4712a1e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports